import { render, staticRenderFns } from "./IcoChevronRightSquare.vue?vue&type=template&id=18185550"
import script from "./IcoChevronRightSquare.vue?vue&type=script&lang=js"
export * from "./IcoChevronRightSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports